import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _4gPlusMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"4g_plus_mobiledata"}/>
}
